import i18n from './i18n';

export const FlashDefinition = {
  updateSuccess: {
    context: [{ detail: i18n.updateSuccess }],
    status: 'success',
  },
};
